import React from 'react';

import { customerSelector } from '@lumapps/customer/ducks/selectors';
import { getCurrentInstance } from '@lumapps/instance/ducks/selectors';
import { useSelector } from '@lumapps/redux/react';
import { useLocation, useRouter } from '@lumapps/router';
import { PageTransition } from '@lumapps/router/components/PageTransition/PageTransition';
import { redirectAbsoluteUrl } from '@lumapps/router/utils';
import { BaseLoadingStatus } from '@lumapps/utils/types/BaseLoadingStatus';

import { isBeekeeperIntegrationEnabled } from '../../ducks/selectors';
import { useBeekeeperContext } from '../../hooks/useBeekeeperContext';
import { push, redirectToBeekeeper } from '../../utils/initRouterBridge';

const UI: React.FC = () => {
    const { pathname, search } = useLocation();
    const { redirect } = useRouter();
    const { slug } = useSelector(getCurrentInstance);
    const { slug: customerSlug } = useSelector(customerSelector);
    const { status } = useBeekeeperContext();

    const path = search ? `${pathname}${search}` : pathname;

    if (status === BaseLoadingStatus.loading || status === BaseLoadingStatus.initial) {
        return <PageTransition />;
    }

    push({ redirect, path, redirectAbsoluteUrl, redirectToBeekeeper, instanceSlug: slug, customerSlug });

    return null;
};

/**
 * BeekeeperRedirectRoute component, used to redirect to a LA page displaying a BKPR feature
 * if the integration is enabled
 * @returns React.FC
 */
export const BeekeeperRedirectRoute: React.FC = () => {
    const isIntegrationEnabled = useSelector(isBeekeeperIntegrationEnabled);

    if (!isIntegrationEnabled) {
        return null;
    }

    return <UI />;
};
